import { Theme } from '@/ui-components/constants/theme'

import { TicketDetail, Results } from '@/redux/reducers/gameReducer'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface TicketGameTranslationResponse {
  id: number
  language_code: string
  name: string
}

export interface TicketGameResponse {
  id: number
  translations: TicketGameTranslationResponse[]
}

export interface TicketRoundGameResponse {
  id: number
  close_at: string
  open_at: string
  is_enable: string
  is_result_confirmed: boolean
  status: string
  round_number: number
  reward_top_two: number
  reward_bottom_two: number
  reward_top_two_flip: number
  reward_bottom_two_flip: number
  reward_top_three: number
  reward_bottom_three: number
  reward_top_three_flip: number
  reward_bottom_three_flip: number
  reward_top_three_front: number
  reward_bottom_three_front: number
  reward_top_three_front_flip: number
  reward_bottom_three_front_flip: number
  reward_run_top: number
  reward_run_bottom: number
}

export interface TicketViewData {
  id: number
  provider_id: number
  provider_user_id: number
  lotto_game_id: number
  lotto_round_game_id: number
  status: string
  cancellation_reason?: string
  bet_amount: number
  win_amount: number
  bonus: number
  ticket_date: string
  created_at: string
  updated_at: string
  is_primary: boolean
  details: TicketDetail[]
  lotto_game: TicketGameResponse
  lotto_round_game: TicketRoundGameResponse
  reward_top_two: number
  reward_bottom_two: number
  reward_top_two_flip: number
  reward_bottom_two_flip: number
  reward_top_three: number
  reward_bottom_three: number
  reward_top_three_flip: number
  reward_bottom_three_flip: number
  reward_top_three_front: number
  reward_bottom_three_front: number
  reward_top_three_front_flip: number
  reward_bottom_three_front_flip: number
  reward_run_top: number
  reward_run_bottom: number
  // Winning numbers for each bet type
  results?: Results
}

export interface TicketViewOnlyState {
  ticket: TicketViewData
  hash: string
  logo_url?: string
  logo_url_dark?: string
  favicon_url?: string
  theme?: string
  language: string
  request_at: string
  expired_at: string
}
export interface ResponseViewTicketData {
  language: string
  theme?: Theme
  logo_url?: string
  logo_url_dark?: string
  favicon_url?: string
  ticket: TicketViewData | undefined
}
export interface ViewTicketState {
  ticketData: ResponseViewTicketData | undefined
  isLoading: boolean
  error: string | undefined
}

const initialState: ViewTicketState = {
  isLoading: false,
  ticketData: undefined,
  error: undefined,
}

const viewTicketSlice = createSlice({
  name: 'viewTicket',
  initialState,
  reducers: {
    fetchViewTicket: (state) => {
      return {
        ...state,
        isLoading: true,
        error: undefined,
      }
    },
    fetchViewTicketSuccess: (
      state,
      action: PayloadAction<ResponseViewTicketData>,
    ) => {
      return {
        ...state,
        isLoading: false,
        ticketData: action.payload,
      }
    },
    fetchViewTicketFailure: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }
    },
  },
})
export const {
  fetchViewTicket,
  fetchViewTicketSuccess,
  fetchViewTicketFailure,
} = viewTicketSlice.actions
export default viewTicketSlice
